import React from 'react';

type WatermarkedImageProps = {
  src: string;
  alt: string;
  className?: string;
  onError?: React.ReactEventHandler<HTMLImageElement>;
  onClick?: React.MouseEventHandler<HTMLElement>;
};

export const WatermarkedImage = ({ src, alt, className, onError, onClick }: WatermarkedImageProps) => {
  return (
    <div className="relative" onClick={onClick}>
      <img src={src} alt={alt} className={className} onError={onError} />
      <div className="absolute inset-0" />
      <img
        src="/images/optimized/checkmate_logo.webp"
        alt=""
        className="pointer-events-none absolute left-1/2 top-1/2 w-1/3 -translate-x-1/2 -translate-y-1/2 opacity-25 brightness-0 invert"
      />
    </div>
  );
};
